import React from "react"
import autobind from "class-autobind"
import SubTotalCardWaveData from "./SubTotalCardWaveData"
import { IWorkforceAssessmentCostSavingsDetailItem } from "../../../../models/data/dashboard/WorkforceAssessment/WorkforceAssessmentDashboard"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IProps {
    savingsList: IWorkforceAssessmentCostSavingsDetailItem[]
}

interface IState {
}

export default class SubTotalsWaveData extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)

        this.state = {
        }
        autobind(this)
    }

    
    render() {
        return (
            <div style={{display: "grid", gridTemplateColumns: "329px 322px 319px 330px", position: "relative", top: -100}}>
                <div style={{gridRow: 1, gridColumn: 1}}>
                    <SubTotalCardWaveData 
                        optimizationSavings={this.props.savingsList[0].EstimatedOptimizationSavings}
                        optimizationText={this.props.savingsList[0].EstimatedOptimizationText} 
                        productivitySavings={this.props.savingsList[0].EstimatedProductivitySavings} 
                        productivityText={this.props.savingsList[0].EstimatedProductivityText} 
                        administrativeSavings={this.props.savingsList[0].EstimatedAdministrativeSavings} 
                        administrativeText={this.props.savingsList[0].EstimatedAdministrativeText} 
                        totalSavings={this.props.savingsList[0].EstimatedTotalSavings} 
                    />
                </div>
                <div style={{gridRow: 1, gridColumn: 2}}>
                    <SubTotalCardWaveData 
                        optimizationSavings={this.props.savingsList[1].EstimatedOptimizationSavings}
                        optimizationText={this.props.savingsList[1].EstimatedOptimizationText} 
                        productivitySavings={this.props.savingsList[1].EstimatedProductivitySavings} 
                        productivityText={this.props.savingsList[1].EstimatedProductivityText} 
                        administrativeSavings={this.props.savingsList[1].EstimatedAdministrativeSavings} 
                        administrativeText={this.props.savingsList[1].EstimatedAdministrativeText} 
                        totalSavings={this.props.savingsList[1].EstimatedTotalSavings} 
                    />                    
                </div>
                <div style={{gridRow: 1, gridColumn: 3}}>
                    <SubTotalCardWaveData 
                        optimizationSavings={this.props.savingsList[2].EstimatedOptimizationSavings}
                        optimizationText={this.props.savingsList[2].EstimatedOptimizationText} 
                        productivitySavings={this.props.savingsList[2].EstimatedProductivitySavings} 
                        productivityText={this.props.savingsList[2].EstimatedProductivityText} 
                        administrativeSavings={this.props.savingsList[2].EstimatedAdministrativeSavings} 
                        administrativeText={this.props.savingsList[2].EstimatedAdministrativeText} 
                        totalSavings={this.props.savingsList[2].EstimatedTotalSavings} 
                    />                    
                </div>
                <div style={{gridRow: 1, gridColumn: 4}}>
                    <SubTotalCardWaveData
                        optimizationSavings={this.props.savingsList[3].EstimatedOptimizationSavings}
                        optimizationText={this.props.savingsList[3].EstimatedOptimizationText} 
                        productivitySavings={this.props.savingsList[3].EstimatedProductivitySavings} 
                        productivityText={this.props.savingsList[3].EstimatedProductivityText} 
                        administrativeSavings={this.props.savingsList[3].EstimatedAdministrativeSavings} 
                        administrativeText={this.props.savingsList[3].EstimatedAdministrativeText} 
                        totalSavings={this.props.savingsList[3].EstimatedTotalSavings} 
                    />                    
                </div>
            </div>
        )
    }
}